<template>
    <div
        v-if="! forceHideBar"
        class="control-bar"
        :style="{
                background: skin.controls.background,
                color: skin.controls.color
            }"
        @mouseenter="show"
        @mouseleave="hide"
    >
        <div class="icon play">
            <PlayToggle :playing="playing" @click="togglePlaying" />
        </div>

        <div v-if="timeline" class="icon duration">
            <Duration />
        </div>

        <div
            class="icon volume"
            :class="{volume_open: '_volume-open'}"
            @mouseenter="volume_open = true"
            @mouseleave="volume_open = false"
        >
            <VolumeControl :open="volume_open" @toggleMute="toggleMute" />
        </div>

        <div v-if="project.chapters" class="icon chapters icon-right">
            <Chapters @click="toggleChapters" />
        </div>

        <div v-if="project.allow_share" class="icon share icon-right">
            <Share @click="toggleShare" />
        </div>

        <Timeline v-if="timeline"  />
    </div>
</template>

<script>
import PlayToggle from '@icons/PlayToggle';
// import Fullscreen from '@icons/Fullscreen';
import VolumeControl from './VolumeControl.vue';
// import Quality from '@icons/Quality';
import Chapters from '@icons/Chapters';
import { mapGetters, mapMutations } from 'vuex';
import Timeline from './Timeline.vue';
import Duration from './Duration.vue';
import Share from '@icons/Share';
import { EventBus } from '../../../lib/EventBus';

export default {
    name: 'ControlBar',
    components: {
        PlayToggle,
        // Fullscreen,
        VolumeControl,
        // Quality,
        Chapters,
        Timeline,
        Duration,
        Share
    },

    computed: {
        ...mapGetters([
            'played',
            'playing',
            'chapters',
            'next',
            'activeNodeId',
            'project',
            'skin',
            'controls',
            'autoplaying'
        ]),

        timeline() {
            return this.project.show_controls;
        },
        switchingNode() {
            return this.next && this.next != this.activeNodeId;
        }
    },

    data: () => ({
        volume_open: false,
        hideDelay: 1000,
        hideTimeout: false,
        forceHideBar: false
    }),

    mounted() {
        EventBus.$on('showControlBar', () => {
            this.show();
        });
        EventBus.$on('hideControlBar', () => {
            this.hide();
        });
        EventBus.$on('forceHideControlBar', () => {
            this.forceHide();
        });
    },

    methods: {
        ...mapMutations(['toggleShare', 'toggleChapters']),

        togglePlaying() {
            this.$emit('playToggle');
        },

        toggleMute() {
            this.$emit('muteToggle');
        },

        show() {
            clearTimeout(this.hideTimeout);

            if (!this.forceHideBar && !this.autoplaying) {
                this.animate({
                    opacity: 1,
                    bottom: '10px'
                });
            }
        },

        hide() {
            clearTimeout(this.hideTimeout);

            this.hideTimeout = setTimeout(() => {
                this.animate({
                    opacity: 0,
                    bottom: '-30px'
                });
            }, this.hideDelay);
        },

        forceHide() {
            this.forceHideBar = true;
            this.animate({
                opacity: 0,
                bottom: '-30px'
            });

            setTimeout(() => {
                this.forceHideBar = false;
            }, 750);
        },

        animate(animation) {
            const targets = this.$el;
            this.$anime.timeline().add(
                Object.assign(
                    {
                        targets,
                        easing: 'easeOutExpo'
                    },
                    animation
                )
            );
        },

       
    },

    watch: {
        playing(newVal) {
            if (!newVal && this.played) {
                this.show();
            }
            if (newVal && this.played) {
                this.hide();
            }
        },
        chapters(opened) {
            if (opened && this.playing) {
                // If we're opening chapters and the video is playing pause it
                this.$emit('playToggle');
            }
            if (
                !opened &&
                !this.playing &&
                this.played &&
                !this.switchingNode
            ) {
                // if closing the chapters while not playing and NOT switching the node unpause the video
                // it'll play regardless which action u take in chapters otherwise
                this.$emit('playToggle');
            }
        }
    }
};
</script>

<style scoped lang="scss">
.control-bar {
    position: absolute;
    bottom: -30px;
    opacity: 0;
    left: 10px;
    border-radius: 10px;
    right: 10px;
    height: 35px;
    z-index: 4000;
    /*width: 100%;*/
    padding-top: 2px;
    overflow: hidden;
    //box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.4);
    padding-left: 10px;
    padding-right: 5px;
}

.icon {
    width: 30px;
    text-align: center;
    height: 20px;
    float: left;
    display: block;
    padding-top: 4px;
    font-size: 12px;

    &.icon-right {
        float: right;
    }
}

.duration {
    padding-top: 2px;
    width: 45px;
}

.play {
    width: 20px;
    padding-top: 6px;
}

.quality {
    width: 25px;
    text-align: right;
}

._volume-open {
    width: 125px;
}

.volume {
    padding-top: 3px;
    font-size: 12px;
    width: 125px;
}

.fullscreen {
    width: 30px;
}

.chapters {
    width: 30px;
}

.share {
    width: 30px;
}
</style>